import axios from "axios";
import { registerApiErrorReport } from "../Components/Errors/errorReporter";
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _getUiLang = "/UIContent";
const getUiLang = axios.create({
  baseURL: checkEnvironment(_basic, _getUiLang)
});


registerApiErrorReport(getUiLang);


/**
 * @param {number} langId 語系代號
 */
export const getUiLangContent = async (langId, userType) => {
  return await getUiLang.get("/GetUIContent", {
    params: { languageID: langId, userType }
  });
};
